import Column from '@components/Column';
import Row from '@components/Row';
import styled from '@emotion/styled';
import { OrderLine } from '@models/order';

import CartContent from './CartContent';
import CartFooter from './CartFooter';
import CartImage from './CartImage';

interface Props {
    item: OrderLine;
}

function CartItem({ item }:Props) {
    return (
        <Container fullWidth spacing={10} >
            <Row spacing={16} align='flex-start' fullWidth>
                <CartImage item={item} />
                <CartContent item={item} />
            </Row>
            <CartFooter item={item} />
        </Container>
    );
}

const Container = styled(Column)`
    border-bottom: 1px solid var(--color-gray3);
    padding: 12px 0 20px;

    &:nth-last-of-type(1) {
        border-bottom: none;
    }  
`;

export default CartItem;
